//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../Features/Features.DividefaceBuilder.js";
import "../no/ScCollector.js";
let d=[[[1,"DivObjects",0,"ScCollector",0],[1,"DivideFaceBuilder",0,"Features.DividefaceBuilder",0],[1,"FaceToDivide",0,"ScCollector",0],[0,"Tolerance",1,0],[0,"Type",1,0]],[[["pFacesToDivide","nCurves","outputCurves"],"CreateIsoclines",{},1,0],[[],"FindMoldUnsplitFace",{},0,0],[["createdFeture","isAdding"],"AddOrRemoveNewDividingObjects",{},2,0]],[]];
SPLM.Tooling.FaceSplitBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.FaceSplitBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.FaceSplitBuilder.FaceSplitType = Object.freeze({
    "CurvesEdges" : "CurvesEdges", "Plane" : "Plane", "Intersection" : "Intersection", "Isocline" : "Isocline"});

export default SPLM;